import React from 'react';
import Loader from '../../component/Loader/loader';

export const BblLoading = () => {
  return (
    <div
      style={{
        background: 'rgb(255, 243, 237)',
        height: '100%',
        backgroundSize: 'cover',
        backgroundPosition: `center bottom 0px`,
        filter: `blur(0px)`,
        scale: 1.05,
        zIndex: -1,
      }}
    >
      <Loader
        open={true}
        onClick={() => {
          //
        }}
      />
    </div>
  );
};
